import React, { useState } from 'react';

interface DayHours {
  isOpen: boolean | null;
  close: string | null;
  open: string | null;
}

interface HoursOfOperationProps {
  hoursOfOperation: { [key: string]: DayHours | null };
}

const formatTime = (time: string) => {
  const [hour, minute] = time.split(':').map(Number);
  const period = hour >= 12 ? 'PM' : 'AM';
  const adjustedHour = hour % 12 || 12;
  return `${adjustedHour}:${minute.toString().padStart(2, '0')} ${period}`;
};

const dayOrder = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

const HoursOfOperation: React.FC<HoursOfOperationProps> = ({ hoursOfOperation }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const sundayHours = hoursOfOperation['sunday'];
  const otherDaysHours = dayOrder.map(day => {
    const dayHours = hoursOfOperation[day];
    return {
      day,
      ...dayHours,
    };
  }).filter(({ isOpen }) => isOpen !== undefined);

  return (
    <div className={`hours-container ${isExpanded ? 'expanded' : ''}`}>
      <div className="summary-text">
        {sundayHours && sundayHours.isOpen
          ? `Sunday Open 24 Hours`
          : `Sunday Closed`}
      </div>
      <div className="see-all" onClick={handleToggle}>
        {isExpanded ? 'See fewer hours' : 'See all hours'}
      </div>
      {isExpanded && (
        <div className="hours-details">
          {otherDaysHours.map(({ day, isOpen, open, close }) => (
            <div key={day} className="day-hours">
              <div className="day">{day.charAt(0).toUpperCase() + day.slice(1)}</div>
              <div className="hours">
                {isOpen
                  ? `${formatTime(open)} - ${formatTime(close)}`
                  : 'Closed'}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HoursOfOperation;
